export enum ModuleTokens {
  Name = 'ticketAuthorization'
}

export const formKey = '[Ticket Authorization] Form';
